import { render, staticRenderFns } from "./FollowUpCard.vue?vue&type=template&id=62f6f894&"
import script from "./FollowUpCard.vue?vue&type=script&lang=js&"
export * from "./FollowUpCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports